<template>
  <div>
    <div class="header-width divcss5">
      <productdetailbanner></productdetailbanner>
    </div>
    <div class=" row body-width divcss5">
      <hhwhyxheader></hhwhyxheader>
    </div>
    <div class=" row body-width divcss5">
      <router-view />
    </div>
  </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import hhwhyxheader from "@/components/contentcoms/prodecutcontentcoms/hhwhyxlcp/hhwhyxheader";


  export default {
    name: "producthhwhyx",
    components: {
      productdetailbanner,
      hhwhyxheader,
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/producthhwhyx.vue